/**
 * Post message types for exchanging tokens
 */
enum TanglTokenMessageEnum {
    Token = 'Token',
    TokenRequest = 'RequestTalanToken',
}

export default TanglTokenMessageEnum;
